import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import reduxLogger from 'redux-logger';
import reduxPromise from 'redux-promise';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import makeRootReducer from './reducers';
const { __DEV__ } = window;



const rootPersistConfig = {
    key: 'root',
    storage,
};

export default (initialState = {}) => {
    // ======================================================
    // Middleware Configuration
    // ======================================================
    const middleware = [thunk, reduxPromise];

    // ======================================================
    // Store Enhancers
    // ======================================================
    const enhancers = [];
    if (__DEV__) {
        middleware.push(reduxLogger);
        const { devToolsExtension } = window;
        if (typeof devToolsExtension === 'function') {
            enhancers.push(devToolsExtension());
        }
    }
    const persistedReducer = persistReducer(rootPersistConfig, makeRootReducer())

    // ======================================================
    // Store Instantiation and HMR Setup
    // ======================================================
    const store = createStore(
        persistedReducer,
        initialState,
        compose(
            applyMiddleware(...middleware),
            ...enhancers,
        ),
    );

    store.asyncReducers = {};

    // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
    // store.unsubscribeHistory = browserHistory.listen(updateLocation(store));

    if (module.hot) {
        module.hot.accept('./reducers', () => {
            const reducers = require('./reducers').default;
            store.replaceReducer(reducers(store.asyncReducers));
        });
    }
 
    return new Promise((resolve, reject) => {
        try {
            persistStore(store, {}, () => resolve(store));
        } catch (error) {
            reject(error);
        }
    });
};
